export default __webpack_public_path__ + "static/online_back-d284b7831985b0b630f46553dec71e95.png";